<template>
  <div class="dod-container" v-if="selectedEmployee" :key="selectedEmployee.id">
    <back-button />
    <div class="content">
      <div class="left-side">
        <employee-personal-data class="mb-4" :employee="selectedEmployee" />
        <employee-management :employee="selectedEmployee" />
      </div>
    </div>
    <div
      v-if="selectedEmployee"
      class="content"
      :key="`${selectedEmployee.id}_messages`"
    >
      <user-messages :employeeId="selectedEmployee.id" />
    </div>
  </div>
</template>

<script>
import BackButton from "../../components/dod/BackButton.vue";
import EmployeeManagement from "../../components/dod/EmployeeManagement.vue";
import EmployeePersonalData from "../../components/dod/EmployeePersonalData.vue";
import UserMessages from "../../components/dod/UserMessages.vue";
import moment from "moment";
export default {
  components: {
    EmployeePersonalData,
    BackButton,
    UserMessages,
    EmployeeManagement,
  },
  name: "DODEmployeeDetails",
  data() {
    return {
      searchValue: "",
      loading: false,
    };
  },

  async mounted() {
    await this.$store.dispatch("resetEmployeeDetails");
    await this.handleNewUserDataLoading();
  },

  computed: {
    urlQuery() {
      return this.$route.query;
    },
    selectedEmployee() {
      return this.$store.getters.getDodSelectedEmployee;
    },
    admin() {
      return this.$store.getters.getLoggedAdmin;
    },
  },

  watch: {
    async urlQuery() {
      await this.handleNewUserDataLoading();
    },
  },

  methods: {
    async handleNewUserDataLoading() {
      const now = moment();
      await this.$store.dispatch("getEmployeeDetails", {
        employeeId: this.$route.params.id,
        ordersMonth: now.get("month") + 1,
        ordersYear: now.get("year"),
      });

      await this.$store.dispatch("getEmployeeMessages", {
        employeeId: this.$route.params.id,
      });

      const needScrollToMessages = this.$route.query.toMessages;
      if (needScrollToMessages) {
        setTimeout(() => {
          const messages = document.getElementById("dod-user-messages");
          if (messages) {
            messages.scrollIntoView({ behavior: "auto" });
          }
        }, 1000);
      }
    },
  },

  destroyed() {
    this.$store.dispatch("resetEmployeeDetails");
  },
};
</script>

<style scoped>
.content {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
  width: 100%;
}
.left-side {
  width: 100%;
  padding-top: 0;
}
</style>
